import React from 'react';
import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';
import style from './block.module.scss';
import { GuedelonButton } from './button';
import { ReactComponent as SmartfireIcon } from '../assets/smartfire_icone.svg';
type GuedelonButtonBlockProps = {
    text: string;
    link: string;
    position: 'left' | 'center' | 'right';
    external: boolean;
    linkType: boolean;
    file: {
        url: string;
    };
};

const InspectorLazy = React.lazy(() => import('./Inspector'));

const GuedelonButtonBlock: React.FC<GuedelonButtonBlockProps> = ({
    position,
    linkType,
    file,
    link,
    external,
}: GuedelonButtonBlockProps) => {
    useInspectorControl(InspectorLazy, []);
    const { isEditing } = useEditor();
    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <div className={style['container-' + position]}>
                    <GuedelonButton href={isEditing ? undefined : linkType ? file?.url : link} external={external}>
                        <EditableText smartProp="text" />
                    </GuedelonButton>
                </div>
            </div>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: GuedelonButtonBlock as React.FC<unknown>,
    smartProps: {
        file: smartProps.object.withDefault({}),
        link: smartProps.string.withDefault(''),
        external: smartProps.bool.withDefault(true),
        linkType: smartProps.bool.withDefault(false), //false: link - true: file
        position: smartProps.string.withDefault('center'),
        text: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Bouton Guedelon',
        icon: SmartfireIcon,
    },
});
